import { CircularProgress } from "@mui/material";



export const PreloaderUI = () => {
  return (
    <CircularProgress />
  )
}